import React, { useEffect, useState } from 'react';
import { CustomAutocompleteFreeSolo } from 'components/shared/DropDown/CustomAutocomplete';

import { PHONENUMBER_REGEX } from 'utils/Regex';
import { useTranslation } from 'react-i18next';
import { LANGUAGES } from 'utils/Constants';

export const AssignChefProject = (props) => {
  const { t } = useTranslation();
  const [name, setName] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [mail, setMail] = useState('');
  const [id, setId] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState('');

  const [selectedLanguage, setSelectedLanguage] = useState(null);

  useEffect(() => {
    setName(props.data.name);
    setFirstName(props.data.firstName);
    setMail(props.data.mail);
    setPhoneNumber(props.data.phoneNumber);

 
    const lang = LANGUAGES.find(
      (l) => l.isoCode === props.data.isoLanguageCode
    );
    setSelectedLanguage(lang || null);
  }, [props, props.data]);

  const handleLanguageChange = (option) => {
    setSelectedLanguage(option);
    props.updateChefProjectsList('isoLanguageCode', option?.isoCode || '');
  };

  return (
    <div className="row row-mb">
      <div className="col-12 col-md-4">
        <div className="label-title">{t('Mail Chef Project*')}</div>
        <CustomAutocompleteFreeSolo
          list={props.list}
          value={mail}
          placeholder="dupont.marie@typix.com"
          onInputChange={(value) => {
            props.updateChefProjectsList('mail', value);
          }}
          setValue={(value) => {
            if (
              value &&
              value.id &&
              props.list.length > 0 &&
              props.list.some((x) => x.id === value.id)
            ) {
              const ChefProject = props.list.find((x) => x.id === value.id);
              props.updateChefProjectsList('firstName', ChefProject.firstName);
              props.updateChefProjectsList('name', ChefProject.lastName);
              props.updateChefProjectsList('mail', ChefProject.mail);
              props.updateChefProjectsList(
                'phoneNumber',
                ChefProject.phoneNumber
              );
              props.updateChefProjectsList(
                'isoLanguageCode',
                ChefProject.isoLanguageCode
              );
              props.updateChefProjectsList('isNew', false);
              props.updateChefProjectsList('id', ChefProject.id);
            } else {
              props.updateChefProjectsList('mail', '');
              props.updateChefProjectsList('phoneNumber', '');
              props.updateChefProjectsList('isoLanguageCode', '');
              props.updateChefProjectsList('firstName', '');
              props.updateChefProjectsList('name', '');
              props.updateChefProjectsList('isNew', true);
              props.updateChefProjectsList('id', 0);
            }
          }}
          getOptionLabel={(option) =>
            option && option.hasOwnProperty('mail') ? option.mail : (option || '')
          }
        />
      </div>
      <div className="col-12 col-md-2">
        <div className="label-title">{t('Prénom*')}</div>
        <CustomAutocompleteFreeSolo
          list={[]}
          value={firstName || ''}
          placeholder="Marie"
          onInputChange={(value) => {
            props.updateChefProjectsList('firstName', value || '');
          }}
          setValue={(value) => {
            props.updateChefProjectsList('firstName', value || '');
          }}
          getOptionLabel={(option) =>
            typeof option === 'string' ? option : (option || '')
          }
        />
      </div>
      <div className="col-12 col-md-2">
        <div className="label-title">{t('Nom*')}</div>
        <CustomAutocompleteFreeSolo
          list={[]}
          value={name || ''}
          placeholder="Dupont"
          onInputChange={(value) => {
            props.updateChefProjectsList('name', value || '');
          }}
          setValue={(value) => {
            props.updateChefProjectsList('name', value || '');
          }}
          getOptionLabel={(option) =>
            typeof option === 'string' ? option : (option || '')
          }
        />
      </div>
      <div className="col-12 col-md-3">
        <div className="label-title">{t('Téléphone')}</div>
        <CustomAutocompleteFreeSolo
          list={[]}
          value={phoneNumber || ''}
          placeholder="O6 07 65 87 60"
          onInputChange={(value) => {
            if (value === '' || PHONENUMBER_REGEX.test(value)) {
              props.updateChefProjectsList('phoneNumber', value || '');
            }
          }}
          setValue={(value) => {
            if (value === '' || PHONENUMBER_REGEX.test(value)) {
              props.updateChefProjectsList('phoneNumber', value || '');
            }
          }}
          getOptionLabel={(option) =>
            typeof option === 'string' ? option : (option || '')
          }
        />
      </div>

      <div className="col-12 col-md-1" style={{ marginTop: 25 }}>
        {props.isDeleteable ? (
            <button className="bt-delete-row" onClick={props.deleteChefProject} style={{ cursor: 'pointer' }} > - </button>
        ) : (
          <div className="bt-plus-circle" onClick={props.addChefProject} style={{ cursor: 'pointer' }} />
        )}
      </div>
    </div>
  );
};
